
export default {
  name: 'Home',
  components:{},
  data() {
    return {
      listImg:[
        {
          url:require('@/static/images/index/bank/1.png')
        },
        {
          url:require('@/static/images/index/bank/2.png')
        },
        {
          url:require('@/static/images/index/bank/3.png')
        },
        {
          url:require('@/static/images/index/bank/4.png')
        },
        {
          url:require('@/static/images/index/bank/5.png')
        },
        {
          url:require('@/static/images/index/bank/6.png')
        },
        {
          url:require('@/static/images/index/bank/7.png')
        },
        {
          url:require('@/static/images/index/bank/8.png')
        },
        {
          url:require('@/static/images/index/bank/9.png')
        },
        {
          url:require('@/static/images/index/bank/10.png')
        },
        {
          url:require('@/static/images/index/bank/11.png')
        },
        {
          url:require('@/static/images/index/bank/12.png')
        },
        {
          url:require('@/static/images/index/bank/13.png')
        },
        {
          url:require('@/static/images/index/bank/14.png')
        },
        {
          url:require('@/static/images/index/bank/15.png')
        },
        {
          url:require('@/static/images/index/bank/16.png')
        }
      ],
      img7:require(`@/static/images/index/7${this.$i18n.locale == 'en' ? '_en' : ''}.png`),
      abountImg:require(`@/static/images/index/about${this.$i18n.locale == 'en' ? '_en' : ''}.png`),
      esgImg:require(`@/static/images/index/esg${this.$i18n.locale == 'en' ? '_en' : ''}.png`),
    }
  },
  methods: {
    goToView(path) {
      this.$router.push(this.localePath(path));
    }
  }
}
